import { render, staticRenderFns } from "./RedirectQuery.vue?vue&type=template&id=9f7f1588"
import script from "./RedirectQuery.vue?vue&type=script&lang=js"
export * from "./RedirectQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports